import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, Divider, Paper, Tooltip, Typography } from "@material-ui/core";
import { unoTheme } from "../../../assets/styles/unoTheme";

//Tables
import Table from '@material-ui/core/Table';
import MyTable from '../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import MyTextField from "../../utils/MyTextField";
import MyAlertBalance from "../../utils/MyAlertBalance";
import MyTextFieldRef from "../../utils/MyTextFieldRef";

import UnoButton from "../../utils/UnoButton";

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import {
    getArrayMonthsWithNames,
    applyMaskAmount,
    applyMaskAccount,
    parseFloatByPtCurrency,
    applyCurrencyMask,
    getMonthName,
    formatAnbimaDateToPt,
    applyMaskAmountFreeDecimals,
    verifyClientPortfolioIsSgregated,
} from "../../utils/utils";

import { getRegimeTypes } from "../../utils/regimeTypes";
import { setBalanceReconciliaded } from "../../../API/client";

//MyInputs
import MySelect from '../../utils/MySelect'
import MyDatePicker from '../../utils/MyDatePicker'

import _ from 'lodash';
import moment from 'moment'

import CircularProgress from '@material-ui/core/CircularProgress';

import EventIcon from '@material-ui/icons/Event';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import QuotizationAssetModal from '../../modals/QuotizationAssetModal';
import { isGenericTitle } from "../../../controllers/TitleController";
import { checkUserIsRole, roles } from "../../utils/user";


const bottomHeight = 40;
//const headerHeight = 170;
const headerHeight = 196;
//const headerHeight = 187;

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'column',
        //height: headerHeight,        
        backgroundColor: unoTheme.hoverTable,
        paddingBottom: '2px',
    },

    topHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        // paddingTop: theme.spacing(2),
        paddingTop: '12px',
        // paddingBottom: theme.spacing(2),
        paddingBottom: '12px',

        '& .actionButtonsHeader': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }
    },

    bottomHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        paddingTop: '12px',
        paddingBottom: '12px',
        borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)'
    },

    main: {
        //paddingBottom: theme.spacing(2),
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        //paddingTop: theme.spacing(2),
        height: 'calc(100% - ' + (headerHeight) + 'px)',

        // '& .mainTable': {
        //     //height: 'calc(100% - ' + (headerHeight + bottomHeight) + 'px)',
        //     height: 'calc(100% - ' + (headerHeight) + 'px)',
        // },

        '& .alertMain': {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            textAlign: 'left',
        }
    },

    bottom: {
        height: bottomHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        height: 'calc(100% - 1px)',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: '#1C2228',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    // detailRow: {
    //     cursor: "pointer",
    //     '& > *': {
    //         borderBottom: 'unset',
    //         padding: '3px 16px 3px 16px !important',
    //         textTransform: 'uppercase',
    //         color: unoTheme.defaultTextColor,
    //         fontWeight: 400,
    //         fontSize: '12px',
    //     },
    //     '&:nth-of-type(odd)': {
    //         backgroundColor: unoTheme.secondaryTuplaTable,
    //     },

    // },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney + ' !important'
    },
    red: {
        color: unoTheme.errorColor + ' !important',
    },
    blue: {
        color: 'blue !important',
    },
    warning: {
        color: unoTheme.warningColor
    },
    labelTotal: {
        fontSize: '13px',
        color: unoTheme.thirdColor
    },
    resultAmount: {
        fontSize: '13px',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    headerTotal: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '& .infosHeaderTotal': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',

            '& .numberQuotas': {
                cursor: 'pointer',
                padding: '0px',
                margin: '0px',
                fontSize: '12px',
                textAlign: 'left',
                transition: 'all .3s ease',

                '&:hover': {
                    color: '#aaaaaa',
                }
            }
        }

    },
    leftHeader: {
        display: 'flex',
        //alignItems: 'center',
        flexDirection: 'column',
    },
    headerDate: {
        display: 'flex',
        alignItems: 'center',
        color: unoTheme.secondaryColor,
        fontSize: '12px',
        '& svg': {
            marginRight: '5px',
        },
        '& > *': {
            fontSize: '14px',
        }
    },

    cnpjLabel: {
        cursor: 'pointer',
        fontSize: '14px',
        color: unoTheme.secondaryColor,

        transition: 'all .3s ease',

        '&:hover': {
            color: '#615b5b',
        }
    },

    fundLabel: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#1C2228'
    },

    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    alertBalance: {
        marginBottom: '5px',
        '& .MuiAlert-message': {
            fontSize: '12px',
            padding: '0px',
            '& span': {
                verticalAlign: 'middle',
            }
        },
        '& .MuiAlert-icon': {
            padding: '0px',
        }
    },

    tabsAsset: {
        background: '#F3F5F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    selectableInfo: {

        transition: 'all .3s ease',

        '&:hover': {
            color: '#aaaaaa',
        }
    },

    cnpjAndFilterRegime: {

        display: 'flex',
        alignItems: 'center',
        //justifyContent: 'center',
    },

    lastQuotasInfo: {
        display: 'flex',
        alignItems: 'center',
        '& span': {
            fontSize: '12px',
        }
    },

    bold: {
        fontWeight: 'bold',
        cursor: 'pointer',

        '&:hover': {
            opacity: 0.7,
        }
    },

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '0px !important',
        }
    },



}));

export default function DetailBalanceCollection(props) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openQuotizationAssetModal, setOpenQuotizationAssetModal] = useState(false);

    //Copy to DAIR
    const textRef = useRef(null);
    //Filtro de regime 
    const [regimeTypes,] = useState(getRegimeTypes(verifyClientPortfolioIsSgregated(clientOn)));
    const [selectedRegimeType, setSelectedRegimeType] = useState(0); //detail
    function handleRegimeType(value) {

        if (regimeTypes.length === 3 && value == 2) {
            value = 3;
        }

        setSelectedRegimeType(value)
        loadTotalInfosObject(content.data.transactions, parseInt(value));
    }

    //Filtro de contas 
    const [numberAccountOptions, setNumberAccountsOptions] = useState([]);
    const [selectedNumberAccountOption, setSelectedNumberAccountOption] = useState(0); //detail
    // function handleRegimeType(value) {
    //     setSelectedRegimeType(value)
    //     loadTotalInfosObject(content.data.transactions, value);
    // }

    const [totalInfosObject, setTotalInfosObject] = useState({
        totalApplications: 0,
        totalApplicationsQuotas: 0,
        totalRescues: 0,
        totalRescuesQuotas: 0,
    });

    function loadTotalInfosObject(transactions, regimeType) {

        //Existe a possibilidade de não haver transações para o ativo selecionado

        if (transactions) {


            let totalApplications = 0;
            let totalApplicationsQuotas = 0;
            let totalRescues = 0;
            let totalRescuesQuotas = 0;

            //Caso o regimeType seja 0 deve-se tratar os totais a partir de todas as transações, informação consolidada
            const transactionsInTheRegime = regimeType == 0 ?
                transactions
                :
                transactions.filter(transaction => transaction.account_regime_id == regimeType);

            console.log("TRASANCTIONS TO TOTAL: ", transactionsInTheRegime);

            if (transactionsInTheRegime) {
                transactionsInTheRegime.forEach(element => {

                    if (element.operation_id == 1) {

                        totalApplications += element.amount ? parseFloat(element.amount) : 0;
                        totalApplicationsQuotas += element.result_qtd_quotas ? element.result_qtd_quotas : 0;

                    } else if (element.operation_id == 2) {

                        totalRescues += element.amount ? parseFloat(element.amount) : 0;
                        totalRescuesQuotas += element.result_qtd_quotas ? element.result_qtd_quotas : 0;

                    }

                });

                setTotalInfosObject({
                    totalApplications: totalApplications,
                    totalApplicationsQuotas: totalApplicationsQuotas,
                    totalRescues: totalRescues,
                    totalRescuesQuotas: totalRescuesQuotas,
                });
            }

        }



    }

    //Tab de saldos do ano ou descrição do ativo
    const [tabValue, setTabValue] = useState(0); //detail
    function handleChangeTabValue(event, value) {
        setTabValue(value)
    }

    function copyToClipboard(e, text) {
        e.stopPropagation();
        navigator.clipboard.writeText(text);
        dispatch(allActions.mainAlertActions.setMainAlert({
            type: 'success',
            message: 'Informação copiada para área de transferência!',
            show: true,
        }));
    };

    function doEditTransaction(transaction, index) {

        //console.log("T: ", transaction)
        // setEditAmount(applyMaskAmount(transaction.amount))
        // setEditOperation(parseInt(transaction.operation_id) - 1)
        // setEditDate(moment.utc(transaction.transaction_date));
        // setEdittingIndex(index)

        dispatch(allActions.rightContentActions.setRightContent({
            path: 'newTransaction',
            update: true,
            transactionToUpdate: transaction,
            data: { //Utilizado para enviar no retorno da tela
                path: 'detailTitleBalanceCollection',
                data: content.data,
                selectedMonth: content.selectedMonth,
                selectedYear: content.selectedYear,
                accounts: content.accounts,
                assets: content.assets,
                titleAssets: content.titleAssets,
                operations: content.operations
            }
        }))
    }

    async function doConcilio(balanceId) {

        //open backdrop
        setOpenBackdrop(true);

        let response = await setBalanceReconciliaded(balanceId,
            currentUser.user.id,
            true, 'title');

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Conciliação realizada com sucesso!'
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao realizar conciliação!'
            }))
        }

        dispatch(allActions.rightContentActions.setAction({
            task: 'updateConcilio',
            data: {
                balanceId: balanceId,
            },
        }))
        setOpenBackdrop(false);
    }

    function getAccountsWithTransactions(transactions) {

        let accountsWithTransactions = ["Conta"];

        if (!transactions) {
            return accountsWithTransactions;
        }

        transactions.forEach(t => {

            if (!accountsWithTransactions.includes(t.account)) {
                accountsWithTransactions.push(t.account);
            }

        });

        return accountsWithTransactions;
    }

    useEffect(() => {

        console.log("DATA DETAIL BALANCE COLLECTION: ", content.data)
        console.log("DATA DETAIL BALANCE COLLECTION ACCOUNTS: ", content.accounts)

        //Fazendo a última cota subir
        // if (content && content.data && content.data.quotas_anbima) {
        //     content.data.quotas_anbima.reverse();
        // }

        //init totalInfosObject
        if (content && content.data) {

            // let arrayNumberAccountsOptions = [];
            // content.accounts.forEach(account => {
            //     arrayNumberAccountsOptions.push(applyMaskAccount(account.number_account));
            // });
            // arrayNumberAccountsOptions.unshift("Contas");

            //setNumberAccountsOptions(arrayNumberAccountsOptions);
            setNumberAccountsOptions(getAccountsWithTransactions(content.data.transactions));
            loadTotalInfosObject(content.data.transactions, 0);
        }


    }, [])

    return (
        <div className={classes.root}>


            <div className={classes.header}>

                <div className={classes.topHeader}>

                    <div className={classes.leftHeader}>
                        <div className={classes.headerDate}>
                            <EventIcon />
                            <Typography
                                align={'left'}

                                className={classes.labelMonth}>
                                {content && content.selectedMonth && content.selectedYear ?
                                    getMonthName(content.selectedMonth).toString().toUpperCase() + " " + content.selectedYear
                                    : ""}
                            </Typography>
                        </div>
                        <Typography
                            align={'left'}
                            className={classes.fundLabel}>
                            {content && content.data ?

                                content.data.titleCod +
                                (!isGenericTitle(content.data) ? '(' + content.data.marking + ')' : "")
                                :
                                ""
                            }

                        </Typography>
                        <div className={classes.cnpjAndFilterRegime}>
                            {
                                !isGenericTitle ?
                                    <Typography
                                        onClick={(e) => copyToClipboard(e, content && content.data ? content.data.marking : "")}
                                        ref={textRef}
                                        align={'left'}
                                        className={classes.cnpjLabel}>
                                        {content && content.data ? content.data.marking : ""}
                                    </Typography> : null
                            }

                            <MySelect
                                style={!isGenericTitle ? { marginLeft: '16px' } : {}}
                                value={selectedRegimeType}
                                verysmall
                                onChange={(e) => handleRegimeType(e.target.value)}
                                options={regimeTypes.map((row, index) => (

                                    <option key={'regime-' + index} value={index}>{row}</option>

                                ))}
                            />

                        </div>

                    </div>

                    <div className={'actionButtonsHeader'}>

                        <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>

                <Divider />

                <div className={classes.bottomHeader}>
                    <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'APLICAÇÔES: '}
                        </Typography>
                        <div class="infosHeaderTotal">
                            <Typography
                                className={[classes.resultAmount, classes.green].join(' ')}>
                                {applyMaskAmount(totalInfosObject.totalApplications, true)}
                            </Typography>
                            <Typography class="numberQuotas" onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(totalInfosObject.totalApplicationsQuotas, false))}>
                                {"(" + applyMaskAmountFreeDecimals(totalInfosObject.totalApplicationsQuotas, false) + ")"}
                            </Typography>
                        </div>

                    </div>
                    <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'RESGATES: '}
                        </Typography>
                        <div class="infosHeaderTotal">
                            <Typography
                                className={[classes.resultAmount, classes.red].join(' ')}>
                                {applyMaskAmount(totalInfosObject.totalRescues, true)}
                            </Typography>
                            <Typography class="numberQuotas" onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(totalInfosObject.totalRescuesQuotas, false))}>
                                {"(" + applyMaskAmountFreeDecimals(totalInfosObject.totalRescuesQuotas, false) + ")"}
                            </Typography>
                        </div>
                    </div>
                    {/* <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'TOTAL: '}
                        </Typography>
                        <div>
                            <Typography
                                className={[classes.resultAmount, content.data.resultAmount > 0 ? classes.green : classes.red].join(' ')}>
                                {content.data && content.data.resultAmount ?
                                    applyMaskAmount(content.data.resultAmount, true) : "-"}
                            </Typography>
                            <Typography className={classes.numberQuotas}>
                                {content.data && content.data.sumQuotasApplication && content.data.sumQuotasRescues ?
                                    applyMaskAmountFreeDecimals(content.data.sumQuotasApplication - content.data.sumQuotasRescues, false) : "-"}
                            </Typography>
                        </div>

                    </div> */}



                </div>



                <Paper square className={classes.tabsAsset}>
                    <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>
                        <Tabs
                            value={tabValue}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleChangeTabValue}>

                            <Tab label={'Movimentações'} />
                            {content && content.data
                                && content.data.title_local_quotas && content.data.title_local_quotas.length > 0 ?
                                <Tab label="PU/IPCAdp" />
                                : <Tab disabled label="PU/IPCAdp" />}
                            <Tab label="CDI" />
                            <Tab label="IGPM" />

                        </Tabs>
                    </div>

                    {
                        content && content.data && content.data.balance_now && content.data.quota_amount_now ?
                            <div className={[classes.lastQuotasInfo, classes.spacingRight2].join(' ')}>
                                <span className={classes.spacingLeft2}>
                                    PU:
                                </span>
                                <span
                                    onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(content.data.balance_now / content.data.quota_amount_now, true, 4))}
                                    className={[classes.bold, classes.spacingLeft1].join(' ')}>{applyMaskAmountFreeDecimals(content.data.balance_now / content.data.quota_amount_now, true, 4)}</span>
                            </div> : null
                    }

                </Paper>

            </div>

            {
                tabValue == 0 ?

                    <div className={classes.main}>

                        {
                            //Verificar role
                            checkUserIsRole(currentUser,
                                [roles.admin,
                                roles.superadmin,
                                roles.advisor]) ?
                                <>
                                    {
                                        content.data.subAssets ?

                                            // exibir lista de alertas
                                            content.data.subAssets.map((row, index) => (
                                                <MyAlertBalance
                                                    key={'my-alert-balance-' + index}
                                                    role={currentUser.user ? currentUser.user.role : null}
                                                    row={row}
                                                    action={(param) => doConcilio(param)} />
                                            ))

                                            :

                                            <MyAlertBalance
                                                role={currentUser.user ? currentUser.user.role : null}
                                                row={content.data}
                                                action={(param) => doConcilio(param)} />
                                    }

                                </>
                                : null
                        }

                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            infosBlack
                            sizeheaders="verySmall"
                            selectable={'true'}
                            size="small">
                            <colgroup>
                                <col width="20%" />
                                <col width="17%" />
                                <col width="18%" />
                                <col width="27%" />
                                <col width="28%" />
                                {/* <col width="10%" /> */}
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableTh} align="center">Data</TableCell>
                                    <TableCell className={classes.tableTh} align="center">Operação</TableCell>
                                    <TableCell className={classes.tableTh} align="center">
                                        <MySelect
                                            rawSelect
                                            value={selectedNumberAccountOption}
                                            verysmall
                                            onChange={(e) => setSelectedNumberAccountOption(e.target.value)}
                                            options={numberAccountOptions.map((row, index) => (

                                                <option key={'account-number-option-' + index} value={index}>{row !== "Conta" ? applyMaskAccount(row) : row}</option>

                                            ))}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.tableTh} align="right">Cotas</TableCell>
                                    <TableCell className={classes.tableTh} align="right">Valor</TableCell>
                                    {/* <TableCell className={classes.tableTh} align="center"></TableCell> */}
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.transactions ?

                                    <TableBody>
                                        {
                                            //content.data.transactions.map((row, index) => (
                                            content.data.transactions.filter(
                                                el =>
                                                    (selectedRegimeType == 0 || el.account_regime_id == selectedRegimeType)
                                                    &&
                                                    (selectedNumberAccountOption == 0 || el.account == numberAccountOptions[selectedNumberAccountOption])
                                            ).map((row, index) => (


                                                <TableRow className={classes.detailRow}
                                                    key={'detail-transaction-' + index}
                                                    onClick={() =>

                                                        //Verificar role
                                                        checkUserIsRole(currentUser,
                                                            [roles.admin,
                                                            roles.superadmin,
                                                            roles.advisor]) ?
                                                            doEditTransaction(row, index) : null
                                                    }>


                                                    <TableCell align="center" className={classes.selectableInfo}
                                                        onClick={(e) => copyToClipboard(e, moment.utc(row.transaction_date).format('DD/MM/YYYY'))}>
                                                        {moment.utc(row.transaction_date).format('DD/MM/YYYY')}
                                                    </TableCell>

                                                    <TableCell align="center" style={{ fontSize: '10px' }}>
                                                        {row.operation}
                                                    </TableCell>

                                                    <TableCell align="center" >
                                                        {applyMaskAccount(row.account)}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.selectableInfo} onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(row.quota_value_transaction))}>
                                                        {row && row.quota_value_transaction ?
                                                            applyMaskAmountFreeDecimals(row.quota_value_transaction) : '-'}
                                                    </TableCell>

                                                    <TableCell align="right" className={
                                                        row.operation == 'Aplicação' ? classes.green : (row.operation == 'Resgate' ? classes.red : classes.blue)
                                                    }>
                                                        {row && row.amount ? applyMaskAmount(row.amount, true) : null}
                                                    </TableCell>



                                                    {/* <TableCell align="center">
                                                        <Tooltip arrow placement={'left'} title={'Editar'}>
                                                            <IconButton size={'small'}
                                                                onClick={() => doEditTransaction(row, index)}>
                                                                <EditIcon />
                                                            </IconButton>

                                                        </Tooltip>

                                                    </TableCell> */}

                                                </TableRow>



                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>

                    </div>

                    :

                    <>

                        {/* IPCA */}
                        {
                            tabValue == 1 ?
                                <div className={classes.main}>


                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">
                                        <colgroup>
                                            <col width="30%" />
                                            <col width="30%" />
                                            <col width="40%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Data</TableCell>
                                                <TableCell align="right">PU ANB</TableCell>
                                                <TableCell align="right">IPCAdp</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {
                                            content && content.data && content.data.title_local_quotas ?

                                                <TableBody>
                                                    {
                                                        content.data.title_local_quotas.map((row, index) => (


                                                            <TableRow className={classes.detailRow}
                                                                key={'detail-quota-' + index}>

                                                                <TableCell align="center">
                                                                    {row.date_quota}
                                                                </TableCell>

                                                                <TableCell align="right" className={classes.green}>
                                                                    {row.pu_anb ? applyMaskAmountFreeDecimals(row.pu_anb, true, 8) : '-'}
                                                                </TableCell>

                                                                <TableCell align="right" className={classes.blue}>
                                                                    {content.data.ipcadp_local && content.data.ipcadp_local[index]
                                                                        && content.data.ipcadp_local[index].date === row.date_quota ? applyMaskAmountFreeDecimals(content.data.ipcadp_local[index].ipca_dp, true, 8) : '-'}
                                                                </TableCell>


                                                            </TableRow>



                                                        ))

                                                    }
                                                </TableBody>
                                                : null
                                        }

                                    </MyTable>


                                </div> : null

                        }

                        {/* CDI */}
                        {
                            tabValue == 2 ?
                                <div className={classes.main}>


                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">
                                        <colgroup>
                                            <col width="30%" />
                                            <col width="70%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Data</TableCell>
                                                <TableCell align="right">Valor CDI</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {
                                            content && content.data && content.data.cdi_month ?

                                                <TableBody>
                                                    {
                                                        content.data.cdi_month.map((row, index) => (


                                                            <TableRow className={classes.detailRow}
                                                                key={'detail-cdi-' + index}>

                                                                <TableCell align="center">
                                                                    {row.date}
                                                                </TableCell>

                                                                <TableCell align="right" className={classes.green}>
                                                                    {row.value ? applyMaskAmountFreeDecimals(row.value, true, 8) : '-'}
                                                                </TableCell>

                                                            </TableRow>



                                                        ))

                                                    }
                                                </TableBody>
                                                : null
                                        }

                                    </MyTable>


                                </div> : null

                        }

                        {/* IGPM */}
                        {
                            tabValue == 3 ?
                                <div className={classes.main}>


                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">
                                        <colgroup>
                                            <col width="30%" />
                                            <col width="70%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Data</TableCell>
                                                <TableCell align="right">Valor IGPM</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {
                                            content && content.data && content.data.igpm_month ?

                                                <TableBody>
                                                    {
                                                        content.data.igpm_month && content.data.igpm_month.map((row, index) => (


                                                            <TableRow className={classes.detailRow}
                                                                key={'detail-igpm-' + index}>

                                                                <TableCell align="center">
                                                                    {row.date}
                                                                </TableCell>

                                                                <TableCell align="right" className={classes.green}>
                                                                    {row.value ? applyMaskAmountFreeDecimals(row.value, true, 8) : '-'}
                                                                </TableCell>

                                                            </TableRow>



                                                        ))

                                                    }
                                                </TableBody>
                                                : null
                                        }

                                    </MyTable>


                                </div> : null

                        }



                    </>


            }


            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }

            <QuotizationAssetModal
                open={openQuotizationAssetModal}
                asset={content
                    && content.data}
                handleCloseQuotizationModal={() => setOpenQuotizationAssetModal(false)}>

            </QuotizationAssetModal>

        </div >
    );
}



